import Bugsnag from '@bugsnag/js'
import ErrorPage from 'next/error';

import { IS_DEBUG } from 'utils/env';

function Page({ statusCode }) {
  return <ErrorPage statusCode={statusCode || 'Error.'} />;
}

Page.getInitialProps = async (ctx) => {
  if (!IS_DEBUG && ctx.err) {
    Bugsnag.notify(ctx.err);
  }

  return ErrorPage.getInitialProps(ctx);
};

export default Page;
